<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_697_4350" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <!-- OLD: fill="currentColor" -->
            <rect width="24" height="24" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_697_4350)">
                <!-- OLD: fill="#22C55E" -->
            <path
                d="M6 23V14.775L2.75 9.5L7.375 2H16.625L21.25 9.5L18 14.775V23L12 21L6 23ZM8.5 4L5.1 9.5L8.5 15H15.5L18.9 9.5L15.5 4H8.5ZM10.95 13.575L7.4 10.05L8.825 8.625L10.95 10.75L15.175 6.5L16.6 7.9L10.95 13.575Z"
                fill="currentColor" />
        </g>
    </svg>
</template>
